import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalContent,
  ModalDescription,
  Space,
  Cross,
  Text,
} from '@cashfree-intl/coherent';
import Lottie from 'react-lottie';

import * as animationData from 'animation/settlements-success.json';
import { CURRENCY_SYMBOL } from 'utils/constants';
import { numberWithCommas } from 'utils/common';
import orangetag from '../../../images/orange-tag.svg';
import sticker from '../../../images/free-sticker.svg';

const ActivationModal = ({ closeModal, freeTrialConstants }) => {
  const defaultOptions = {
    loop: false,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <Modal open $maxWidth="556" className="od-activation-modal">
      <ModalContent>
        <Space justifyContent="flex-end">
          <Cross
            onClick={closeModal}
            size="lg"
            data-event-name="Form_ActivationModal_Icon_Click"
            data-ignore-inner-text="true"
          />
        </Space>
        <ModalDescription>
          <div className="text-center mb-4 mr-top-n24">
            <Lottie options={defaultOptions} height={100} width={100} />
            <Text variant="h20" strong className="text-center">
              On-Demand Settlements Activated
              <br />
              with {freeTrialConstants.odFreeTrialEligibleDays} Days Free Trial
            </Text>
          </div>
          <div className="p-4 mb-2 od-activation-details">
            <div className="grid mb-2">
              <div />
              <Text
                variant="b12"
                className="font-normal w-500 free-trial-tag-bg"
                style={{ backgroundImage: `url(${orangetag})` }}
              >
                During Free Trial
              </Text>
              <Text variant="b12" className="font-normal w-500">
                After Free Trial
              </Text>
            </div>
            <div className="grid mb-1">
              <Text variant="b14">Max Limit</Text>
              <Text variant="h16" strong color="warning">
                <span className="w-500">{CURRENCY_SYMBOL.INR}</span>{' '}
                {numberWithCommas(freeTrialConstants.odFreeTrialEligibleAmount)}
              </Text>
              <Text variant="b14" strong>
                <span className="w-500">{CURRENCY_SYMBOL.INR}</span>{' '}
                {numberWithCommas(freeTrialConstants.odDefaultLimit)}&nbsp;
                (daily)
              </Text>
            </div>
            <div className="grid">
              <Text variant="b14">Charges</Text>
              <img src={sticker} alt="Free" />
              <Text variant="b14" strong>
                {freeTrialConstants.odDefaultRate}% + GST
              </Text>
            </div>
          </div>
        </ModalDescription>
      </ModalContent>
    </Modal>
  );
};

ActivationModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  freeTrialConstants: PropTypes.object,
};

export default ActivationModal;
